export const PURCHASE = 'purchase' // 立即購買
export const PRODUCT_PAGE = 'product_page' // 前往產品頁面
